import { render } from "./ModalAttributeList.vue?vue&type=template&id=1dfd8bb4"
import script from "./ModalAttributeList.vue?vue&type=script&lang=js"
export * from "./ModalAttributeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__